'use strict';

var i18n = require('i18next');
var EditPorts = require('actions/ports/EditPorts');
var FormView = require('actions/ports/FormView');
var StaticView = require('actions/ports/StaticView');

/**
 * Action configuration for the VLAN ports action component.
 */
module.exports = {
  title: i18n.t('actionPorts.title'),
  Model: EditPorts,
  FormView: FormView,
  TextView: StaticView,
};
